import { useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { AttachFileOutlined } from "@mui/icons-material";
import api from "../../../../../../services/api";
import AnexosCircuito from "../../circuito/anexosCircuito";
import FormWoman from "../../../../../../components/artsPersonComponent/formWoman";
import useStyles from "./styles";

// Seção "Anexos" do preview (read-only): busca os anexos do circuito e
// renderiza via AnexosCircuito em editMode=false. Estado `anexos` e o
// useEffect de fetch migraram de previewData.js para dentro deste
// subcomponente (decisão do controlador, Task 7 da decomposição); só monta quando abaAtiva === 1, então trocar de aba e voltar desmonta/remonta e refaz o fetch (idempotente, não é problema).
export default function AnexosPreview({ form, setSnackbar }) {
	const theme = useTheme();
	const styles = useStyles();
	const [anexos, setAnexos] = useState([]);

	useEffect(() => {
		if (!form?.id) {
			setAnexos([]);
			return;
		}
		const fetchAnexos = async () => {
			try {
				const response = await api.post("/anexos/findMany", {
					entityType: "Circuito",
					entityId: form.id,
				});
				setAnexos(response?.data || []);
			} catch (error) {
				console.error("Erro ao buscar anexos no preview:", error);
			}
		};
		fetchAnexos();
	}, [form?.id]);

	return (
		<>
			<Box sx={styles.boxContent}>
				<AttachFileOutlined color="primary" />
				<Typography variant="mySubtitle2">
					Anexos:
				</Typography>
			</Box>
			<Box sx={{ px: 2, py: 1 }}>
				{/* Sem anexos: ilustração no lugar do card vazio, mesmo padrão do clientesSwap */}
				{anexos?.length > 0 ? (
					<AnexosCircuito
						circuitoAnexos={anexos}
						editMode={false}
						setSnackbar={setSnackbar}
					/>
				) : (
					<FormWoman
						mainFill={theme.palette.secondary.dark}
						mainText={{ before: "Parece que ainda não\nhá ", highlight: "Anexos", after: " por aqui." }}
						subText={"Os anexos aparecerão\nassim que forem criados"}
					/>
				)}
			</Box>
		</>
	);
}
